<template>
    <div class="row reports-chart-summary">
        <div class="col" :class="{'d-sm-flex flex-sm-column': fullHeight}">
            <template v-if="loaded">
                <div class="row" :class="{'flex-grow-1': fullHeight}">
                    <div class="col-12">
                        <div class="card border-0" :class="{'h-100': fullHeight}">
                            <div class="card-body p-0 chart-wrapper">
                                <ChartElement
                                    :value="chartData"
                                    :showFilters="false"
                                    :isCardStyle="false"
                                    @tool="onTool"
                                    :allowExport="chartExport"
                                    :notDataMsg="notFoundMsg"
                                    alignTools="left"
                                    classTitle="subtitle"/>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { HasLoadingState, HasReport } from './mixins/index';
    import GlobalMixin from '@/app/shared/mixins/global';

    export default {
        name: 'reportChart',
        mixins: [
            HasLoadingState,
            HasReport,
            GlobalMixin
        ],
        components: {
            ChartElement: () => import(/* webpackChunkName: "dashboard-chart" */ '@/app/shared/components/dashboard/DashboardChart'),
        },
        props: {
            id: {
                type: String,
                required: true,
            },
            type: {
                type: String,
                required: true,
                validator: function (value) {
                    return ['pie', 'horizontalBar'].indexOf(value) !== -1
                }
            },
            field: {
                type: String,
                default: 'total',
            },
            fullHeight: {
                type: Boolean,
                default: true,
            },
            config: {
                type: Object,
                default: () => ({}),
            },
            color: {
                type: String,
                default: 'rgba(116, 151, 255, 1)'
            },
        },
        data() {
            return {
            }
        },
        computed: {
            chartData() {
                let isHorizontalbar = this.type.toLowerCase() == 'horizontalbar';
                let cfg = {
                    id: this.id,
                    key: `chart-${this.id}`,
                    title: this.title,
                    label: null,
                    type: 'chart',
                    chart: {
                        type: isHorizontalbar ? 'bar' : this.type,
                        data: {
                            labels: [],
                            datasets: []
                        },
                        options: {
                            ...(isHorizontalbar ?{indexAxis: 'y'} : {}),
                            ...this.config,
                        }
                    }
                };

                if(this.data.length){
                    let _labels = [];
                    let _data = [];
                    let _colors = [];

                    this.data.map( item => {
                        _labels.push(item.name + ' (' + item[this.field] + ')')
                        _data.push(item[this.field])
                        _colors.push(item.color ? item.color : this.color)
                    });

                    cfg.chart.data.labels = _labels;
                    cfg.chart.data.datasets = [
                        {
                            data: _data,
                            borderColor: _colors,
                            backgroundColor: _colors,
                            borderWidth: isHorizontalbar ? 2 : 1
                        }
                    ];
                }

                return cfg;
            },
            chartExport() {
                return this.hasData && this.allowExportData;
            }
        },
        methods: {
            onTool: function(params) {
                let {key} = params;
                switch (key) {
                    case 'export':
                        this.onExport()
                        break;
                    default:
                        break;
                }
            }
        }
    }
</script>

<style lang="scss" scoped="">
.chart-wrapper {
    min-height: 256px;
    .chart {
        margin: 0 auto;
    }
}
</style>